import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import DernieresNouvellesDuSysteme from "./sections/DernieresNouvellesDuSysteme";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <DernieresNouvellesDuSysteme />
      <Footer />
    </div>;
}